import { Component, EventEmitter, HostListener, Input, Output } from "@angular/core";

/**
 * Task Visibility Toggle - Toggle prive/public custom
 * Design moderne style Todoist/Notion
 *
 * Usage:
 * <app-task-visibility-toggle
 *   [(isPrivate)]="task.isPrivate"
 * ></app-task-visibility-toggle>
 */
@Component({
  selector: "app-task-visibility-toggle",
  templateUrl: "./task-visibility-toggle.component.html",
  styleUrls: ["./task-visibility-toggle.component.scss"],
})
export class TaskVisibilityToggleComponent {
  /** Etat prive de la tache */
  @Input() isPrivate = false;

  /** Mode desactive */
  @Input() disabled = false;

  /** Mode compact (sans label) */
  @Input() compact = false;

  /** Emis quand la visibilite change */
  @Output() isPrivateChange = new EventEmitter<boolean>();

  /** Toggle la visibilite */
  toggle(): void {
    if (this.disabled) return;
    this.isPrivate = !this.isPrivate;
    this.isPrivateChange.emit(this.isPrivate);
  }

  /** Gestion du clavier */
  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggle();
    }
  }

  /** Label d'etat pour le tooltip */
  get tooltipLabel(): string {
    return this.isPrivate ? "Tache privee (visible uniquement par vous et les assignes)" : "Tache visible par tous";
  }

  /** Label court pour l'affichage */
  get displayLabel(): string {
    return this.isPrivate ? "Privee" : "Visible";
  }
}
